import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import topTitle from '@/components/title';
import { templatePanel, templateDetail } from './request';
import { func, getDate } from '@/utils/public';
import draggable from 'vuedraggable';
import customModel from './customModel.vue';
import echartsItem from './echartsItem.vue';
import moment from 'moment';
export default {
  components: {
    topTitle,
    draggable,
    echartsItem,
    customModel
  },
  props: {
    customerId: {
      type: Number,
      default: 0
    },
    menu: {
      type: String,
      default: 'home.dashboardFrontPage'
    },
    type: {
      type: String,
      default: ''
    },
    queryMethod: {
      //时间筛选方式
      type: String,
      default: ''
    },
    timeFrame: {
      type: String,
      default: ''
    },
    bulletinBoardList: {
      type: Object,
      default() {
        return {};
      }
    },
    frontPage: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      grpupA: {
        name: 'site',
        pull: 'clone',
        put: false
      },
      panelList: [],
      previewList: [],
      previewCopyList: [],
      current: -1,
      isPanelShow: false,
      panelIndex: 0
    };
  },
  created() {
    this.$nextTick(() => {
      if (this.menu.indexOf('dashboardFrontPage') > -1) {
        if (!this.frontPage.previewList) {
          this.panelList = [];
          this.getTemplateDetail();
        } else {
          this.panelList = this.frontPage.panelList;
          this.previewList = this.frontPage.previewList;
        }
      } else {
        const INFO = this.bulletinBoardList[this.type];
        if (!INFO) {
          this.panelList = [];
          this.getTemplateDetail();
        } else {
          if (INFO.length != 0) {
            this.panelList = INFO.panelList;
            this.previewList = INFO.previewList;
            this.$emit('setInfo', {
              queryMethod: INFO.queryMethod,
              timeFrame: INFO.timeFrame
            });
          } else {
            this.getTemplateDetail();
          }
        }
      }
    });
  },
  methods: {
    formatDate(date) {
      // debugger;
      let _date = date.split('~');
      _date = moment(_date[0]).format(this.getFormatDate()) + '~' + moment(_date[1]).format(this.getFormatDate());
      return _date || '';
    },
    async getTemplateDetail() {
      this.panelList = await templatePanel({
        customerId: this.customerId,
        menu: this.menu,
        type: this.type
      });
      const {
        frontPage,
        dataBoard
      } = await templateDetail({
        customerId: this.customerId
      });
      this.homeList = frontPage || [];
      if (this.menu.indexOf('dashboardFrontPage') > -1 && frontPage) {
        const arr = frontPage.sort(func) || [];
        let arr_new = [null, null, null, null, null];
        arr.map(item => {
          arr_new.splice(item.sort - 1, 1, item);
        });
        this.previewList = arr_new;
        this.$emit('setItem', this.type);
      } else if (this.menu.indexOf('dashboardDataBoard') > -1 && dataBoard) {
        let dataBoardArr = [];
        dataBoard.map(item => {
          if (item.keyType == this.type) {
            dataBoardArr = item.children;
          }
        });
        const arr = dataBoardArr.sort(func) || [];
        let arr_new = [null, null, null, null, null];
        arr.map(item => {
          arr_new.splice(item.sort - 1, 1, item);
        });
        this.previewList = arr_new;
        if (arr.length != 0) {
          this.$emit('setInfo', arr[0]);
        } else {
          this.$emit('setInfo', {
            queryMethod: 'WHOLE',
            timeFrame: 'MONTH'
          });
        }
        this.$emit('setItem', this.type);
      } else if (this.menu.indexOf('dashboardDataBoard') > -1 && !dataBoard) {
        this.$emit('setInfo', {
          queryMethod: 'WHOLE',
          timeFrame: 'MONTH'
        });
      }
    },
    titleFun(val) {
      let name = '222';
      if (val && val.panel && val.panel.length != 0 && val.panel[0].name) {
        name = val.panel[0].name;
      }
      return name;
    },
    async handleDelPanel(val) {
      if (this.previewList[val].createAt) {
        this.$emit('delArr', this.previewList[val]);
      }
      this.panelList.push(this.previewList[val].panel[0]);
      this.previewList.splice(val, 1, null);
      this.current = -1;
    },
    onMove(e) {
      if (this.previewList[e.to.id]) return false;
      return true;
    },
    addFun(e, index) {
      const val = this.panelList.find(item => item.id == Number(e.clone.id));
      this.isPanelShow = true;
      this.panelIndex = Number(e.clone.dataset.num);
      this.current = index;
      this.$nextTick(() => {
        this.$refs.customRef.init(val);
      });
    },
    addTemplateFun(val, itemData) {
      const obj = {
        customerId: this.customerId,
        menu: this.menu,
        type: this.type,
        queryMethod: '',
        timeFrame: '',
        panelId: itemData.id,
        sort: this.current + 1,
        showForm: val.showForm,
        dictionariesId: val.id ? val.id.join(',') : '',
        dictionaries: val.dictionaries,
        panel: [itemData]
      };
      this.previewList[this.current] = obj;
      this.panelList.splice(this.panelIndex, 1);
      this.$emit('setItem', this.type);
    },
    getTimeFrame(val) {
      const dateInfo = getDate(val);
      return dateInfo.startTime + '~' + dateInfo.endTime;
    }
  }
};